import { render, staticRenderFns } from "./registrationForm.vue?vue&type=template&id=732e5820&scoped=true"
import script from "./registrationForm.vue?vue&type=script&lang=js"
export * from "./registrationForm.vue?vue&type=script&lang=js"
import style0 from "./registrationForm.vue?vue&type=style&index=0&id=732e5820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732e5820",
  null
  
)

export default component.exports